export var KMLElementType;
(function (KMLElementType) {
    /**
     * Virtual elements can't be 'constructed' they are simple members of the class hierarchy.
     */
    KMLElementType[KMLElementType["Virtual"] = 0] = "Virtual";
    // Concrete element types
    KMLElementType[KMLElementType["Placemark"] = 1] = "Placemark";
    KMLElementType[KMLElementType["Document"] = 2] = "Document";
    KMLElementType[KMLElementType["Folder"] = 3] = "Folder";
    KMLElementType[KMLElementType["Point"] = 4] = "Point";
    KMLElementType[KMLElementType["LineString"] = 5] = "LineString";
    KMLElementType[KMLElementType["LinearRing"] = 6] = "LinearRing";
    KMLElementType[KMLElementType["Polygon"] = 7] = "Polygon";
    KMLElementType[KMLElementType["MultiGeometry"] = 8] = "MultiGeometry";
    KMLElementType[KMLElementType["Style"] = 9] = "Style";
    KMLElementType[KMLElementType["StyleMap"] = 10] = "StyleMap";
    KMLElementType[KMLElementType["LineStyle"] = 11] = "LineStyle";
    KMLElementType[KMLElementType["PolyStyle"] = 12] = "PolyStyle";
    KMLElementType[KMLElementType["IconStyle"] = 13] = "IconStyle";
    KMLElementType[KMLElementType["LabelStyle"] = 14] = "LabelStyle";
    KMLElementType[KMLElementType["BalloonStyle"] = 15] = "BalloonStyle";
    KMLElementType[KMLElementType["ListStyle"] = 16] = "ListStyle";
})(KMLElementType || (KMLElementType = {}));
export var AltitudeMode;
(function (AltitudeMode) {
    AltitudeMode[AltitudeMode["ClampToGround"] = 0] = "ClampToGround";
    AltitudeMode[AltitudeMode["RelativeToGround"] = 1] = "RelativeToGround";
    AltitudeMode[AltitudeMode["Absolute"] = 2] = "Absolute";
})(AltitudeMode || (AltitudeMode = {}));
export var StyleState;
(function (StyleState) {
    StyleState[StyleState["Normal"] = 0] = "Normal";
    StyleState[StyleState["Highlight"] = 1] = "Highlight";
})(StyleState || (StyleState = {}));
export var ColorMode;
(function (ColorMode) {
    ColorMode[ColorMode["Normal"] = 0] = "Normal";
    ColorMode[ColorMode["Random"] = 1] = "Random";
})(ColorMode || (ColorMode = {}));
export var DisplayMode;
(function (DisplayMode) {
    DisplayMode[DisplayMode["Default"] = 0] = "Default";
    DisplayMode[DisplayMode["Hide"] = 1] = "Hide";
})(DisplayMode || (DisplayMode = {}));
export var ListItemType;
(function (ListItemType) {
    ListItemType[ListItemType["Check"] = 0] = "Check";
    ListItemType[ListItemType["CheckOffOnly"] = 1] = "CheckOffOnly";
    ListItemType[ListItemType["CheckHideChildren"] = 2] = "CheckHideChildren";
    ListItemType[ListItemType["RadioFolder"] = 3] = "RadioFolder";
})(ListItemType || (ListItemType = {}));
export var IconState;
(function (IconState) {
    IconState[IconState["Open"] = 0] = "Open";
    IconState[IconState["Closed"] = 1] = "Closed";
    IconState[IconState["Error"] = 2] = "Error";
    IconState[IconState["Fetching0"] = 3] = "Fetching0";
    IconState[IconState["Fetching1"] = 4] = "Fetching1";
    IconState[IconState["Fetching2"] = 5] = "Fetching2";
})(IconState || (IconState = {}));
